<template>
  <div class="search-form">
    <b-row>
      <b-col cols="8">
        <b-form @submit.prevent>
          <b-input-group size="sm">
            <b-form-input
              v-model.trim="form.keyword"
              type="search"
              :placeholder="$l('form_placeholder_goodsKeyword') || '搜索产品编码/店铺产品编码/补货单号/NC编号'"
              @keyup.enter="query"
            />
            <b-input-group-append>
              <b-button variant="link" size="sm" class="search-dropdown-button" squared @click="openAdvqueryDialog">
                {{ $l('INDEX.advanced_search') || '高级搜索' }}
              </b-button>
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      append-to-body
      v-el-dialog-drag
    >
      <el-form :model="form" size="small" label-width="120px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_scmName') || '出货工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/ecom/common/factory/dictSelect"
                multiple
                clearable
                filterable
                style="width: 100%"
                :placeholder="$l('form_placeholder_scmCode') || '请选择出货工厂'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_ecomWarehouseName') || '出货仓库'">
              <dict-select
                v-model="form.listEcomWarehouseCode"
                url="/ecom/common/warehouse/dictSelect"
                multiple
                clearable
                filterable
                style="width: 100%"
                :placeholder="$l('form_placeholder_ecomWarehouseCode') || '请选择出货仓库'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fbaDc') || 'FBA配送中心'">
              <el-input v-model.trim="form.fbaDc" clearable :placeholder="$l('form_placeholder_fbaDc') || '请输入FBA配送中心'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fbaId') || 'FBA货件编号'">
              <el-input v-model.trim="form.fbaId" clearable :placeholder="$l('form_placeholder_fbaId') || '请输入FBA货件编号'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_ncNo') || 'NC编号'">
              <el-input v-model.trim="form.ncNo" clearable :placeholder="$l('form_placeholder_ncNo') || '请输入NC编号'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_goodsColor') || '颜色'">
              <el-input v-model.trim="form.goodsColor" clearable :placeholder="$l('form_placeholder_goodsColor') || '请输入颜色'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_storeName') || '店铺名称'">
              <el-input v-model.trim="form.storeName" clearable :placeholder="$l('form_placeholder_storeName') || '请输入店铺名称'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_settlementFactory') || '结算工厂'">
              <dict-select
                v-model="form.listSettlementFactoryCode"
                url="/ecom/common/factory/dictSelect"
                multiple
                clearable
                filterable
                style="width: 100%"
                :placeholder="$l('form_placeholder_settlementFactoryCode') || '请选择结算工厂'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_businessNature') || '业务性质'">
              <el-input v-model.trim="form.businessNature" clearable :placeholder="$l('form_placeholder_businessNature') || '请输入业务性质'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_contractNo') || '合同号'">
              <el-input v-model.trim="form.contractNo" clearable :placeholder="$l('form_placeholder_contractNo') || '请输入合同号'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderNo') || '订单号'">
              <el-input v-model.trim="form.orderNo" clearable :placeholder="$l('form_placeholder_orderNo') || '请输入订单号'" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsReadyDate') || '货好日期'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker v-model="form.goodsReadyDateStart" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-date-picker v-model="form.goodsReadyDateEnd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_customerDeliveryDate') || '客户交期'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker v-model="form.customerDeliveryDateStart" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-date-picker v-model="form.customerDeliveryDateEnd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_loadingDate') || '产装日期'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker v-model="form.loadingDateStart" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-date-picker v-model="form.loadingDateEnd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const goodsInitForm = {
  keyword: '',
  listScmCode: [],
  listEcomWarehouseCode: [],
  fbaDc: '',
  fbaId: '',
  ncNo: '',
  goodsColor: '',
  storeName: '',
  listSettlementFactoryCode: [],
  businessNature: '',
  contractNo: '',
  orderNo: '',
  goodsReadyDateStart: '',
  goodsReadyDateEnd: '',
  customerDeliveryDateStart: '',
  customerDeliveryDateEnd: '',
  loadingDateStart: '',
  loadingDateEnd: '',
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...goodsInitForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', { ...this.form })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...goodsInitForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
